const FileUpload = ({ value, name, id, pickedFileValue, touched, errors, handleChange, handleBlur, disabled }) => {

  return (
    <div className='form-control' style={{ display: 'flex', flexDirection: 'row', gap: 10, alignItems: 'center', paddingLeft: '2px' }}>
      <input
        type="file"
        id={id}
        name={name}
        error={touched && errors}
        onChange={handleChange}
        onBlur={handleBlur}
        style={{ display: 'none' }}
      />
      <label htmlFor={name}
        className='mt-2'
        style={{
          display: "inline-block",
          padding: "4px",
          backgroundColor: disabled ? "#6eaaf4" : "#007BFF",
          color: "#FFFFFF",
          borderRadius: "4px",
          cursor: `${disabled ?  'auto' : 'pointer'}`,
          fontSize: "14px"
        }}>
        {value || pickedFileValue ? 'Update File' : 'Upload File'}
      </label>

      <p
        className="mt-3"
        style={{
          flex: 1,
          whiteSpace: "nowrap",
          overflow: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        {value ? value.split("\\").pop() : "No file chosen"}
      </p>
    </div>
  )
}

export default FileUpload